@let isIos = isIos$;
<div [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'" class="alert-wrapper ion-overlay-wrapper">
    <div [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'" class="alert-message">
        @if (title || svgIcon || iconName) {
            <div class="alert-title-container">
                @if (svgIcon && !iconName) {
                    <div class="alert-icon-container">
                        <ion-icon class="font-size-{{ iconSize }}" color="{{ iconColor }}" src="assets/svg/{{ svgIcon }}"></ion-icon>
                    </div>
                }
                @if (iconName && !svgIcon) {
                    <div class="alert-icon-container">
                        <ion-icon class="font-size-{{ iconSize }}" color="{{ iconColor }}" name="{{ iconName }}"></ion-icon>
                    </div>
                }
                <h2 [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'" class="alert-title">
                    {{ title | translate: paramsTitle }}
                </h2>
            </div>
        }
        @if (description) {
            <p
                [innerHTML]="description | translate: paramsDescription"
                [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'"
                class="alert-description"
            ></p>
        }
    </div>
    <div [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'" class="alert-button-group" [ngClass]="buttonsWrapperClasses">
        @for (button of buttons; track button.trigger) {
            <ion-button
                (click)="pushAction(button.trigger)"
                expand="full"
                class="alert-button"
                fill="{{ button.fill }}"
                color="{{ button.color }}"
                [ngClass]="isIos ? 'sc-ion-alert-ios' : 'sc-ion-alert-md'"
            >
                {{ button.title | translate }}
            </ion-button>
        }
    </div>
</div>
